import {TargetBlank} from '@wandb/weave/common/util/links';
import {Icon} from '@wandb/weave/components/Icon';
import {useLocalStorage} from '@wandb/weave/util/useLocalStorage';
import React from 'react';

import {
  LogsPageLocation,
  trackLogsPage,
} from '../../services/analytics/logsPageEvents';
import DOC_URLS from '../../util/doc_urls';
import {Banner} from '../Banner';

type LogLabelsBannerProps = {
  analyticsLocation?: LogsPageLocation;
};

export const LogLabelsBanner = ({analyticsLocation}: LogLabelsBannerProps) => {
  const [isDismissed, setIsDismissed] = useLocalStorage<boolean>(
    'logLabelsBannerDismissed',
    false
  );

  if (isDismissed) {
    return null;
  }

  return (
    <Banner variant="info" className="mb-16 gap-16">
      <div className="flex gap-16">
        <Icon name="lightbulb-info" className="shrink-0" />
        <span>
          <span className="font-semibold">This run is in shared mode.</span> Log
          lines are labeled by process to reflect distributed execution.
        </span>
      </div>
      <div className="flex items-center gap-12">
        <TargetBlank
          href={DOC_URLS.logsDistributedSingleRun}
          className="whitespace-nowrap text-moon-600 hover:text-moon-600 hover:underline"
          onClick={() => {
            if (analyticsLocation) {
              trackLogsPage({
                action: 'Labels banner docs clicked',
                location: analyticsLocation,
              });
            }
          }}>
          Learn more
        </TargetBlank>
        <Icon
          className="h-18 w-18"
          name="close"
          role="button"
          aria-label="dismiss banner"
          onClick={() => {
            setIsDismissed(true);
            if (analyticsLocation) {
              trackLogsPage({
                action: 'Labels banner dismissed',
                location: analyticsLocation,
              });
            }
          }}
        />
      </div>
    </Banner>
  );
};
